module.exports = __webpack_public_path__ + "img/1.fb9e50b4.jpg";